// NotificationIcon.jsx
import React from "react";
import { BellOutlined } from "@ant-design/icons";
import useGlobalStore from "../../../store/store";
import "./NotificationIcon.css";

const NotificationIcon = ({ onClick }) => {
  const unreadCount = useGlobalStore((state) => state.alerts.unreadCount);

  return (
    <div
      className="notification-icon-container"
      onClick={onClick}
      style={{ position: "relative", cursor: "pointer", padding: "4px" }}
    >
      <BellOutlined
        className="notification-icon"
        style={{
          fontSize: "20px",
          color: "var(--primary-text-color)",
          display: "block",
        }}
      />
      {unreadCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            minWidth: "16px",
            height: "16px",
            backgroundColor: "#ff4d4f",
            color: "white",
            fontSize: "10px",
            fontWeight: 600,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1.5px solid var(--header-bg-color, white)",
            lineHeight: 1,
            padding: "0 3px",
            boxSizing: "border-box",
          }}
        >
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </div>
  );
};

export default NotificationIcon;
